<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header">
            <h2>Add Testimonial</h2>
          </div>
          <div class="body">
            <ValidationObserver v-slot="{ passes }">
              <form @submit.prevent="passes(createCoupon)" id="basic-form">
                <ValidationProvider
                  name="title"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group"
                    :class="{
                      errors: errors.length && !addtestimonial.title,
                      success: addtestimonial.title,
                    }"
                  >
                    <span class="float-label">
                      <input
                        type="text"
                        v-model="addtestimonial.title"
                        class="form-control"
                        id="name"
                        placeholder="First Name*"
                      />
                      <label for="name" class="control-label">
                        Testimonial Title*
                      </label>
                      <div class="line"></div>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && !addtestimonial.title"
                      ></i>
                      <i class="fa fa-check" v-if="addtestimonial.title"></i>
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  name="image"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group"
                    :class="{
                      errors:
                        errors.length && !addtestimonial.author_image.name,
                      success: addtestimonial.author_image.name,
                    }"
                  >
                    <span class="float-label">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="inputGroupFile01"
                          @change="upload"
                        />
                        <label class="custom-file-label" for="inputGroupFile01">
                          Author Image
                        </label>
                        <i
                          class="fa fa-times"
                          v-if="
                            errors.length && !addtestimonial.author_image.name
                          "
                        ></i>
                        <i
                          class="fa fa-check"
                          v-if="addtestimonial.author_image.name"
                        ></i>
                      </div>
                      <div class="ml-2">
                        {{ addtestimonial.author_image.name }}
                      </div>
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  name="name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group"
                    :class="{
                      errors: errors.length && !addtestimonial.author_name,
                      success: addtestimonial.author_name,
                    }"
                  >
                    <span class="float-label">
                      <input
                        type="text"
                        class="form-control"
                        v-model="addtestimonial.author_name"
                        placeholder="Author Name*"
                        @keypress="onlyNumber($event)"
                      />
                      <label for="name" class="control-label">
                        Author Name*
                      </label>
                      <div class="line"></div>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && !addtestimonial.author_name"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="addtestimonial.author_name"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  name="email"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group"
                    :class="{
                      errors: errors.length && !addtestimonial.author_email,
                      success: addtestimonial.author_email,
                    }"
                  >
                    <span class="float-label">
                      <input
                        type="text"
                        class="form-control"
                        v-model="addtestimonial.author_email"
                        placeholder="Author Name*"
                        @keypress="onlyNumber($event)"
                      />
                      <label for="name" class="control-label">
                        Author Email*
                      </label>
                      <div class="line"></div>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && !addtestimonial.author_email"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="addtestimonial.author_email"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  name="rating"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group form-select single-multiselect select-option-custom"
                    :class="{
                      errors: errors[0],
                      success: addtestimonial.rating && !errors[0],
                    }"
                  >
                    <span class="float-label">
                      <label for="rating">Rating*</label>
                      <multiselect
                        placeholder=""
                        v-model="addtestimonial.rating"
                        :show-labels="false"
                        :options="['1', '2', '3', '4', '5']"
                      ></multiselect>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && errors[0]"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="addtestimonial.rating && !errors[0]"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  name="description"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group"
                    :class="{
                      errors: errors.length && !addtestimonial.description,
                      success: addtestimonial.description,
                    }"
                  >
                    <label
                      for="email_notification_content"
                      class="control-label"
                    >
                      Description*
                    </label>
                    <span class="float-label">
                      <vue-editor
                        v-model="addtestimonial.description"
                      ></vue-editor>
                      <div class="line"></div>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && !addtestimonial.description"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="addtestimonial.description"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  name="status"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group form-select single-multiselect select-option-custom"
                    :class="{
                      errors: errors[0],
                      success: addtestimonial.status && !errors[0],
                    }"
                  >
                    <span class="float-label">
                      <label for="status">Select Status*</label>
                      <multiselect
                        placeholder=""
                        v-model="addtestimonial.status"
                        :show-labels="false"
                        :options="['Active', 'InActive']"
                      ></multiselect>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && errors[0]"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="addtestimonial.status && !errors[0]"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.back()"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const { ValidationObserver, ValidationProvider } = require("vee-validate");
const { VueEditor } = require("vue2-editor");
export default {
  name: "AddTestmonialComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    ValidationObserver,
    ValidationProvider,
    Multiselect: () => import("vue-multiselect"),
    VueEditor,
  },
  methods: {
    createCoupon() {
      console.log(this.addtestimonial);
    },
    upload(e) {
      if (e.target.files.length > 0) {
        let file = e.target.files[0];
        this.addtestimonial.author_image = file;
      }
    },
    onlyNumber(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
      if (/^\W$/.test(event.key)) {
        event.preventDefault();
      }
    },
  },
  data() {
    return {
      addtestimonial: {
        title: "",
        author_image: "",
        author_name: "",
        author_email: "",
        rating: "",
        description: "",
        status: "",
      },
    };
  },
};
</script>
